import { render, staticRenderFns } from "./UserAliasForm.vue?vue&type=template&id=354e8c36&scoped=true"
import script from "./UserAliasForm.vue?vue&type=script&lang=ts"
export * from "./UserAliasForm.vue?vue&type=script&lang=ts"
import style0 from "./UserAliasForm.vue?vue&type=style&index=0&id=354e8c36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354e8c36",
  null
  
)

export default component.exports